import { ioListOptions, ioSaveOption } from '@/febos/servicios/api/herramientas.api';

export async function saveNewWareHouse({ commit }, payload) {
  try {
    commit('SET_LOADING', true);
    const response = await ioSaveOption(payload.param, payload.body);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
}

export async function loadListWareHouses({ commit }, payload) {
  try {
    commit('SET_LOADING', true);
    const response = await ioListOptions(payload);
    commit('SET_LIST_WAREHOUSES', response.data);
  } finally {
    commit('SET_LOADING', false);
  }
}
